<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" sm="12" lg="12">
        <table class="table">
          <thead>
            <th>{{ $t('order.order_id') }}</th>  
            <th>{{ $t('order.transaction_id') }}</th>  
            <th>{{ $t('order.payment_method') }}</th>  
            <th>{{ $t('order.currency') }}</th>  
            <th>{{ $t('order.total') }}</th>  
            <th>{{ $t('order.commission') }}</th>  
            <th>{{ $t('order.client') }}</th>  
            <th>{{ $t('order.created_at') }}</th>  
          </thead>
          <tbody>
            <tr v-for="order in orders">
              <td>{{ order.id }}</td>  
              <td>{{ order.transaction_id }}</td>  
              <td>{{ order.payment_method }}</td>  
              <td>{{ order.currency }}</td>  
              <td>{{ order.total }}</td>  
              <td>{{ order | getCommission }}</td>  
              <td>{{ order.client.first_name }} {{ order.client.last_name }}</td>  
              <td>{{ order.created_at }}</td>  
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>

// import LineExample from './charts/LineExample';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Models from '@/store/ORM/models.js';
import SupplierService from '@/services/supplier.service.js';

export default {
  name: 'dashboard',
  data: function () {
    return {
      orders:[]
    }
  },
  created(){
    
    SupplierService.getOrders(this.getUser.id)
    .then((res)=>{
      if(res.data.success){
        this.orders = res.data.payments;
        console.log(this.orders);
      }
    })
    .catch((error)=>{
      alert(error);
    });
  },
  methods: {
    
  },
  computed: {
    getUser() {
      return Models.Nutritionist.query().first()
    }
  },
  filters:{
    getCommission(order){
      let comm = 0;

      order.products.forEach((prod)=>{
        comm += parseFloat(prod.pivot.commission);
      })

      return comm.toFixed(2);

    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
